import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { RoutingService } from '../../services/routing.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TenantService } from '../../services/tenant.service';

@Component({
  selector: 'app-cash-app-cross-sell',
  templateUrl: '../cross-sell.container.component.html',
  styleUrls: ['./cash-app-cross-sell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CashAppCrossSellComponent implements OnInit, OnDestroy {
  constructor(
    private routingService: RoutingService,
    private tenantService: TenantService,
    private translationService: TranslateService,
    private cdr: ChangeDetectorRef
  ) { }

  private resellerIdSubcription: Subscription;

  public title: string;
  public description: string;
  public callToAction: string;
  public imageSource: string;
  public resellerId: string;

  ngOnInit(): void {
    this.routingService.persistRoute('cash-app');
    this.resellerIdSubcription = this.tenantService.resellerId$.subscribe(
      resellerId => {
        this.resellerId = resellerId?.toLowerCase();
        this.setContent(this.resellerId);
        this.cdr.markForCheck(); 
      }
    );
  }

  ngOnDestroy(): void {
    this.resellerIdSubcription.unsubscribe();
  }

  setContent = (resellerId: string): void => {
    switch (resellerId) {
      case 'jpmorgan':
        this.title = this.translationService.instant('ARC_COMPOSITE_JPM_CROSS_SELL_CASHAPP_TITLE');
        this.description = '';
        this.callToAction = '';
        this.imageSource = '';
        break;
      default:
        this.title = this.translationService.instant('ARC_COMPOSITE_CROSS_SELL_CASHAPP_TITLE');
        this.description = this.translationService.instant('ARC_COMPOSITE_CROSS_SELL_CASHAPP_DESCRIPTION');
        this.callToAction = 'https://www.billtrust.com/solutions/cash-application?utm_medium=network&utm_source=bt&utm_campaign=ws-contact-sales-platform-cash-app';
        this.imageSource = 'assets/images/cross-sell/cashapp.svg';
        break;
    }
  }
}